<div class="editor-page">
  <div class="editor-body" [ngClass]="{ extended: sidebar?.grid.extended, reduced: sidebar?.grid.hidden }">
    <div class="editor-header-tools">
      <div class="current-siteinfo" [hidden]="sidebar?.grid.hidden">
        <div class="title">
          <span>Site Details</span>
          <div class="actions">
            <button class="btn-secondary-action-lil ms-2" (click)="editmode.active = true">
              <i class="fa fa-pencil"></i>
            </button>
          </div>
        </div>
        <div class="content">
          <div *ngIf="minisitedb" class="status">
            <span
              class="bullet"
              title="Site in Live"
              [ngClass]="{ enabled: minisiteConfiguration?.mapConfig.enabled }"></span>
            <a [href]="minisitedb.url" target="_blank">/{{ minisiteConfiguration?.mapConfig.client }}</a>
          </div>
          <div *ngIf="!editmode.active; else editable">
            <div>
              <span>{{ minisiteConfiguration?.mapConfig.venue_id }}</span>
            </div>
            <div>
              <span>{{ minisiteConfiguration?.mapConfig.map_id }}</span>
            </div>
          </div>
          <ng-template #editable>
            <div>
              <input type="text" class="custom-input" placeholder="venue ID" [(ngModel)]="editmode.venue_id" />
              <input type="text" class="custom-input" placeholder="map ID" [(ngModel)]="editmode.map_id" />
              <div class="edit-actions">
                <button class="btn-secondary-action-lil ms-2 active" (click)="editMapConfig()">CARGAR</button>
                <button class="btn-secondary-action-lil ms-2 active" (click)="editmode.active = false">CANCELAR</button>
              </div>
            </div>
          </ng-template>
        </div>
        <!--                 <span>{{workflow.name}}</span>
                <span class="bullet" title='Site in Live' [ngClass]="{'enabled':minisiteConfiguration?.mapConfig.enabled}"></span>
                <span *ngIf="minisiteConfiguration?.mapConfig.enabled">Public</span>
                <span *ngIf="!minisiteConfiguration?.mapConfig.enabled">Private</span>
                <div class="editor-header-cell ps-0" *ngIf="!editmode.active else editable">
                    <span class="me-2">{{minisiteConfiguration?.mapConfig.venue_id}}</span> <span class="ms-2">{{minisiteConfiguration?.mapConfig.map_id}}</span>
                    <button class="btn-secondary-action-lil ms-2" (click)="editmode.active = true">
                        <i class="fa fa-pencil"></i>
                    </button>
                </div>
                <ng-template #editable>
                    <div class="editor-header-cell">
                        <input type="text" placeholder="venue ID" [(ngModel)]="editmode.venue_id">
                        <input type="text" placeholder="map ID" [(ngModel)]="editmode.map_id">
                        <button class="btn-secondary-action-lil ms-2 active" (click)="editMapConfig()">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="btn-secondary-action-lil ms-2 active" (click)="editmode.active = false">
                            <i class="fa fa-times"></i>
                        </button>
        
                    </div>
                </ng-template>
                <div *ngIf="minisitedb" class="editor-header-cell ms-auto">
                    <div class="url-link">
                        <a [href]="minisitedb.url" target="_blank">{{minisitedb.url}}</a>
                    </div>
                </div> -->
      </div>
      <app-sb-editor-tools></app-sb-editor-tools>
      <div class="save-btn-wrapper">
        <button class="save-btn" (click)="saveSite()">
          <span *ngIf="!sidebar?.grid.hidden; else reduced">Guardar</span>
          <ng-template #reduced>
            <i class="fa fa-save"></i>
          </ng-template>
        </button>
      </div>
    </div>
    <div class="sidebar-container">
      <app-sb-editor-sidebar></app-sb-editor-sidebar>
    </div>
    <div class="external-component">
      <sblib
        *ngIf="minisiteConfiguration"
        #sitebuilder
        [loadOptions]="{ siteConfiguration: minisiteConfiguration, siteParams: minisiteConfigurationParams }">
      </sblib>
    </div>
  </div>
</div>
